/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import BaseApi, {EventData} from '../api/BaseApi';
import {PulseApi as Contract, PulseNotification, PulseResponse} from '@adobe/exc-app/pulse';
import {messenger} from '../Messenger';

enum EVENTS {
  EXC_PULSE = 'EXC_PULSE'
}

export enum NOTIFICATION_TYPE {
  APPROVAL_REQUEST = 'approval_request',
  APPROVAL_REQUEST_ACTION = 'approval_request_action',
  ACCESS_REQUEST = 'access_request',
  ACCESS_REQUEST_ACTION = 'access_request_action',
  ASSIGNED = 'assigned',
  SHARED = 'shared',
  MENTIONS = 'mentions',
  UPDATES_ON_SUBSCRIBED_OBJECT = 'updates_on_subscribed_object',
  ERROR_COMPLETED_WITH_ERRORS = 'completed_with_errors',
  ERROR_FAILED_WITH_ERRORS = 'failed_with_errors',
  ERROR_DEFAULT_MESSAGE = 'errors_default_message',
  OTHERS = 'others'
}

export class PulseApi extends BaseApi implements Contract {
  public send = this.pulseApiHandler('POST');
  public NOTIFICATION_TYPE = NOTIFICATION_TYPE;
  private pulseApiHandler(method: string) {
    return (notifications: PulseNotification[]): Promise<PulseResponse> => {
      const uniqueIndex = this.getUniqueID();
      this.messenger.send(EVENTS.EXC_PULSE, {data: notifications, id: uniqueIndex, method});
      return this.getPromise(uniqueIndex);
    };
  }
  public receive(event: MessageEvent): void {
    let {type, value}: EventData = event.data || {};
    if (type === EVENTS.EXC_PULSE) {
      this.promises[value.id].resolve(value.pulseResponse);
      delete this.promises[value.id];
    }
  }
}

let instance: Contract;
export default function pulse() {
  if (!instance) {
    instance = new PulseApi(messenger);
  }
  return instance;
}
